"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports.default=void 0;var robustAcos=function robustAcos(value){if(value>1){return 1}if(value<-1){return-1}return value};var _default=robustAcos;exports.default=_default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/geolib/es/robustAcos.js
// module id = /UYM
// module chunks = 1